module.exports = __webpack_public_path__ + "img/empty.528e31bf.png";